import { useMutation } from '@apollo/client';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { graphql } from '~/apollo/generated/v4';
import { uploadVomRoute } from '~/paths';

const DELETE_VOM = graphql(`
  mutation DeleteVom($id: ID!) {
    virtualOutcropModelDelete(id: $id) {
      result {
        id
      }
    }
  }
`);

export function DeleteVom({
  vomId,
  children,
}: {
  vomId: number;
  children: (handleDelete: () => void, loading: boolean) => any;
}) {
  const navigate = useNavigate();
  const [deleteVom, { loading }] = useMutation(DELETE_VOM, {
    variables: { id: vomId },
  });

  async function handleDelete() {
    if (!window.confirm('The selected VOM will be permanently deleted.')) {
      return;
    }

    try {
      await deleteVom();
      toast.success('VOM successfully deleted.');
      navigate(uploadVomRoute());
    } catch (err) {
      console.log('Error deleting vom', err);
      toast.error(
        'There was a problem deleting the VOM. It may have pictures associated with it,or has already been deleted.',
      );
    }
  }

  return children(handleDelete, loading);
}
